// PC 端默认主题说明：
// 1. 现在默认进入翠绿色主题：'emerald-theme'
// 2. 如果想恢复之前的默认主题，把下面改回：'default-theme'
export const DEFAULT_THEME_PRIMARY = '#13D89B'
export const DEFAULT_THEME_PRIMARY_RGB = '19, 216, 155'
export const DEFAULT_THEME_TYPE = 'emerald-theme'
export const THEME_CLASS_SUFFIX = 'promote_index_a promote_index_b promote_index_c'

export function applyTheme(themeType = DEFAULT_THEME_TYPE) {
  if (typeof document === 'undefined' || !document.body) {
    return themeType || DEFAULT_THEME_TYPE
  }
  const finalThemeType = themeType || DEFAULT_THEME_TYPE
  document.body.className = finalThemeType + ' ' + THEME_CLASS_SUFFIX
  return finalThemeType
}

export function getThemeColor(variableName = '--theme-primary', fallback = DEFAULT_THEME_PRIMARY) {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return fallback
  }
  const targets = [document.body, document.documentElement]
  for (const target of targets) {
    if (!target) {
      continue
    }
    const value = window.getComputedStyle(target).getPropertyValue(variableName).trim()
    if (value) {
      return value
    }
  }
  return fallback
}

export function getThemeRgb(variableName = '--theme-primary-rgb', fallback = DEFAULT_THEME_PRIMARY_RGB) {
  return getThemeColor(variableName, fallback)
}



// WEBPACK FOOTER //
// ./src/utils/theme.js